// src/containers/DebriefTable/helpers.js

/**
 * Format phone number to standardized format
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return "-";
  const cleaned = phone.replace(/\D/g, "");
  if (cleaned.length === 10) {
    return `+91 ${cleaned.slice(0, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7)}`;
  }
  return phone;
};

/**
 * Generate avatar color based on name
 */
// export const getAvatarColor = (name) => {
//   if (!name) return "#999999";
//   const colors = [
//     "#FF6B6B", "#4ECDC4", "#45B7D1", "#FFA07A", "#98D8C8",
//     "#F7DC6F", "#BB8FCE", "#85C1E2",
//   ];
//   const charCode = name.charCodeAt(0) + name.charCodeAt(name.length - 1);
//   return colors[charCode % colors.length];
// };

/**
 * Get initials from name
 */
// export const getInitials = (name) => {
//   if (!name) return "?";
//   return name
//     .split(" ")
//     .slice(0, 2)
//     .map((n) => n.charAt(0).toUpperCase())
//     .join("");
// };

/**
 * Get status badge color
 */
export const getStatusBadgeStyle = (status) => {
  const statusMap = {
    Selected: { color: "#065F46", background: "#D1FAE5", border: "#6EE7B7" },
    Rejected: { color: "#7F1D1D", background: "#FEE2E2", border: "#FCA5A5" },
    "In Progress": { color: "#1E40AF", background: "#DBEAFE", border: "#93C5FD" },
    "On Hold": { color: "#7C2D12", background: "#FED7AA", border: "#FDBA74" },
    "Not Reviewed": { color: "#4B5563", background: "#F3F4F6", border: "#D1D5DB" },
    Pending: { color: "#92400E", background: "#FEF3C7", border: "#FCD34D" },
  };
  return statusMap[status] || statusMap["Not Reviewed"];
};

/**
 * Debounce function
 */
export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

/**
 * Filter data based on search and filter criteria
 */
export const filterData = (data, filters) => {
  let filtered = [...data];

  if (filters.company) {
    filtered = filtered.filter((item) => item.company_name === filters.company);
  }

  if (filters.role) {
    filtered = filtered.filter((item) => item.role_title === filters.role);
  }

  if (filters.recruiter) {
    filtered = filtered.filter(
      (item) => item.recruiter_name === filters.recruiter
    );
  }

  if (filters.jobCode) {
    filtered = filtered.filter((item) => item.job_code === filters.jobCode);
  }

  if (filters.search) {
    const searchLower = filters.search.toLowerCase().trim();
    filtered = filtered.filter((item) => {
      const candidateName = `${item.first_name || ""} ${item.last_name || ""}`.toLowerCase();
      return (
        (item.first_name && item.first_name.toLowerCase().includes(searchLower)) ||
        (item.last_name && item.last_name.toLowerCase().includes(searchLower)) ||
        (candidateName.includes(searchLower)) ||
        (item.email && item.email.toLowerCase().includes(searchLower)) ||
        (item.primary_no && item.primary_no.toLowerCase().includes(searchLower)) ||
        (item.company_name && item.company_name.toLowerCase().includes(searchLower)) ||
        (item.role_title && item.role_title.toLowerCase().includes(searchLower)) ||
        (item.recruiter_name && item.recruiter_name.toLowerCase().includes(searchLower))
      );
    });
  }

  return filtered;
};
/**
 * Get active filter count
 */
// export const getActiveFilterCount = (filters) => {
//   let count = 0;
//   if (filters.company) count++;
//   if (filters.role) count++;
//   if (filters.recruiter) count++;
//   if (filters.jobCode) count++;
//   if (filters.search) count++;
//   return count;
// };

// /**
//  * Get filter chips/tags
//  */
// export const getFilterChips = (filters) => {
//   const chips = [];
//   if (filters.company) chips.push({ key: "company", label: `Company: ${filters.company}` });
//   if (filters.role) chips.push({ key: "role", label: `Role: ${filters.role}` });
//   if (filters.recruiter) chips.push({ key: "recruiter", label: `Recruiter: ${filters.recruiter}` });
//   if (filters.jobCode) chips.push({ key: "jobCode", label: `Job Code: ${filters.jobCode}` });
//   if (filters.search) chips.push({ key: "search", label: `Search: "${filters.search}"` });
//   return chips;
// };

/**
 * Truncate text with ellipsis
 */
export const truncateText = (text, maxLength = 25) => {
  if (!text || text === "") return "-";
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};
